import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createFeatureFlag, createLanguage, fetchFeatureFlags, fetchLanguages, removeFeatureFlag, removeLanguage, updateFeatureFlag, updateLanguage } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditLanguageModal from "./AddEditLanguageModal";


const Languages = ({}) => {
    const [editLanguage, setEditLanguage] = useState(null)
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const languages = useSelector(store => store.app.languages);
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(fetchLanguages())
    }, [])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleDelete = (language) => {
        if(language.id) {
            dispatch(removeLanguage(language.id))
                .then(()=>{
                    dispatch(fetchLanguages())
                    setShowAddEditModal(false)
                })
        }
    }

    const handleSave = (language) => {
        if(language.id) {
            dispatch(updateLanguage(
                language.id,
                language.IsoLanguage,
                language.Description
            )).then(()=>{
                dispatch(fetchLanguages())
                setShowAddEditModal(false)
            })
        } else {
            dispatch(createLanguage(
                language.IsoLanguage,
                language.Description
            )).then(()=>{
                dispatch(fetchLanguages())
                setShowAddEditModal(false)
            })
        }
    }
    
    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h2>Languages</h2>
            <Button onClick={()=>{
                setEditLanguage(null);
                setShowAddEditModal(true);
            }}>Create language</Button>
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Iso Language</th>
                    <th>Description</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {languages && languages.map(language => {
                    return <tr key={language.id} onClick={()=>{
                        setShowAddEditModal(true)
                        setEditLanguage(language)
                    }}>
                        <td>{language.id}</td>
                        <td>{language.IsoLanguage}</td>
                        <td>{language.Description}</td>
                        <td>{language.updated_at}</td>
                        <td>{language.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditLanguageModal editLanguage={editLanguage} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleSave} onDelete={handleDelete}/>
    </div>
} 

export default Languages